import api from '../../../../api/axiosInstance';

// ---------- CONFIG ----------
export const fetchConfig = (businessId) =>
  api.get(`/wizard/${businessId}/config`).then(r => r.data);

export const saveConfig = (businessId, payload) =>
  api.post(`/wizard/${businessId}/config`, payload);

// ---------- LIVE SEARCH ----------
export function searchUsers(q, businessId, signal) {
  return api
    .get(
      `/wizard/${businessId}/users`,
      { params: { q }, signal }
    )
    .then((r) => r.data);
}

export function searchBusinesses(q, businessId, signal) {
  return api
    .get(
      `/wizard/${businessId}/businesses`,
      { params: { q }, signal }
    )
    .then((r) => r.data);
}

export const fetchServices = (businessId)=>
  api.get(`/wizard/${businessId}/services`).then(r=>r.data);

// ---------- AVATAR UPLOAD ----------
export const uploadEmployeeImage = async ({ file, businessId, employeeId }) => {
  // 1) signed URL
  const { uploadUrl, fileName } = await api
    .post(`/wizard/${businessId}/generate-upload-url`, { type: 'avatar' })
    .then(r => r.data);

  // 2) PUT file to GCS
  await fetch(uploadUrl, {
    method : 'PUT',
    headers: { 'Content-Type': file.type || 'image/jpeg' },
    body   : file,
  });

  // 3) persist DB link
  await api.post(`/wizard/${businessId}/save-upload-metadata`, {
    fileName, type: 'avatar', employeeId,
  });

  return fileName;
};
